// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import useProductContext from "@store/Framework/Store/Data/Products/ProductsHooks/useProductContext";

export const handleSourceOfTruth = (catalogueSource: number | string | undefined, apiSource: string | undefined) => {
    if (apiSource && Number(apiSource) > 0) {
        return Number(apiSource);
    }
    return Number(catalogueSource);
};

const useHandleMinimumMultupleSalesQuantity = (
    product: ProductModel | undefined = undefined,
    productInfo: ProductInfo | undefined = undefined,
) => {
    const productContext = useProductContext();
    const { product: productFromContext, productInfo: productInfoFromContext } = productContext;
    product = product || productFromContext;
    productInfo = productInfo || productInfoFromContext;
    const { minimumQuantity: erpMinimumQuantity, multipleQuantity: erpMultipleQuantity } =
        productInfo?.pricing?.additionalResults || {};
    let productMultipleSalesQuantity: string | number = product?.properties?.productMultipleQuantity;
    let productMinimumQuantity: string | number = product?.properties?.productMinimumQuantity;

    if (!productMinimumQuantity) {
        productMinimumQuantity = product?.minimumOrderQty || 1;
    }
    if (!productMultipleSalesQuantity) {
        productMultipleSalesQuantity = product?.detail?.multipleSaleQty || 1;
    }
    const minimumQuantity = handleSourceOfTruth(productMinimumQuantity, erpMinimumQuantity) || 1;
    const multipleQuantity = handleSourceOfTruth(productMultipleSalesQuantity, erpMultipleQuantity) || 1;

    return { minimumQuantity, multipleQuantity };
};

export default useHandleMinimumMultupleSalesQuantity;
